import React from 'react';
import Autorenew from '@material-ui/icons/Autorenew';
import Fab from '@material-ui/core/Fab';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';


export default class Preview extends React.Component {

  state = {
    src: ''
  }
  
  srcWithoutParam = '';
  listeners = []

  componentDidMount() {
    let src = '/live/' + window.programId;
    if (window.isVod)
      src = '/vod/' + window.programId;
    
    this.setState({
      src: src
    })
    this.srcWithoutParam = src;
    
    this.listeners.push(window.sdk.on('updatePreview', (custom) => {
      this.setState({
        src: this.srcWithoutParam + '?custom=' + encodeURIComponent(JSON.stringify(custom))
      })
    }));
    
  }
  
  preview = () => {
    window.sdk.emit('needUpdatePreview');
  }
  
  componentWillUnmount() {
    for (var i in this.listeners) {
      this.listeners[i]();
    }
  }

  render() {
    return (
      <div style={{ padding: '20px', background:'#ccc' }}>
        <Grid item xs={12} align={ 'center' }>
          <Fab onClick={ this.preview } color="secondary" variant="extended">
            <Autorenew  />
            Recharger la preview
          </Fab>
        </Grid>
        {this.state.src != '' &&
          <Typography style={{ marginTop: '20px' }} variant="body1">
              Si player uniquement visualiser ici : <a href={ this.state.src } target="_blank">Voir</a>
          </Typography>
        }
        {this.state.src != '' &&
          <iframe style={{ marginTop: '10px', minWidth: '200px', minHeight: '200px', background: 'white' }} src={ this.state.src }></iframe>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Manager/Custom/Preview.js